import { createFileRoute, redirect } from '@tanstack/react-router'
import { SupplierListView } from '@/features/suppliers/suppliers'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/suppliers/')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'supplier.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: SupplierListView,
})
